import React, {
    useContext
} from 'react';
import { TrackingContext } from '@vrbo/react-event-tracking';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@ferris/react';
import Input from '@ferris/react/components/forms/Input';

import { createInteractionEvent } from '../../../../utils/EventProviders/EgClickstreamUtil';
import Accordion from '../../../../ui/components/accordion';
import { VrboCtx } from '../../../../contexts/vrbo';

function CompetitorLink(props) {
    const {
        title,
        description,
        display,
        fieldLabel
    } = props;

    if (!display) return null;
    const { trigger } = useContext(TrackingContext);
    const {
        setCompetitorLinkValue,
        loading
    } = useContext(VrboCtx) || {};

    const competitorLinkOnChange = (e) => {
        setCompetitorLinkValue(e.target.value.trim());
    };

    const onToggle = (open) => {
        trigger('interaction', createInteractionEvent(
            open ? 'card.opened' : 'card.closed',
            'Estimateresults',
            'Estimateresults'
        ));
    };

    const AccordionIcon = (
        <Icon
            name="keyboard-arrow-down"
        />
    );

    return (
        <Accordion
            title={title}
            onToggle={onToggle}
            headerLevel="3"
            icon={AccordionIcon}
            customClass={cn('competitor-link')}
        >
            <p>{description}</p>
            <Input
                onChange={competitorLinkOnChange}
                floatLabel
                label={fieldLabel}
                disabled={loading}
            />
        </Accordion>
    );
}

CompetitorLink.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    display: PropTypes.bool.isRequired,
    fieldLabel: PropTypes.string.isRequired
};

export default CompetitorLink;
